<template>
  <div class="input-group">
    <date-picker v-model="date" :config="options" :wrap="true" @dp-change="onChange"></date-picker>
    <div class="input-group-addon">
      <span class="input-group-text far fa-calendar-alt calendar-align"></span>
    </div>
  </div>
</template>

<script>
import datePicker from "vue-bootstrap-datetimepicker";

export default {
  components: {
    datePicker
  },

  props: {
    value: {
      default: null,
      required: true,
      type: Date
    }
  },

  data() {
    return {
      changedDate: "",
      options: {
        format: "DD-MM-YYYY",
        locale: "nl",
        useCurrent: false,
        //debug: true,
        icons: {
          time: "far fa-clock",
          date: "far fa-calendar",
          up: "fas fa-arrow-up",
          down: "fas fa-arrow-down",
          previous: "fas fa-chevron-left",
          next: "fas fa-chevron-right",
          today: "fas fa-calendar-check",
          clear: "far fa-trash-alt",
          close: "far fa-times-circle"
        }
      }
    };
  },

  computed: {
    date: {
      //ipv een watch een computed met een setter
      get: function() {
        return this.value;
      },
      set: function(newValue) {
        //props zijn niet aanpasbaar
        this.changedDate = newValue;
      }
    }
  },
  methods: {
    onChange: function(event) {
      if (!!event && !!event.date) {
        this.$emit("input", event.date.toDate()); //moment date
      }
    }
  }
};
</script>

<style scoped>
.calendar-align {
  min-height: 38px;
  padding-top: 9px;
}
</style>
 

